var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwimmer3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 43,
    viewBox: "0 0 25 43",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "opklzt8tca",
    d: "M0 0h8.214v6.407H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ix9mpp3hhc",
    d: "M0 0h7.047v6.909H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.31 3.05c.78 1.3.415 6.134.23 8.55.8.748 2.06 1.755 2.32 6.08.002.047.86 1.39.86 5.05 0 .706.043 1.058-1.44 1.56 0 .1-.734 1.055-1.05-1.22-.1-.718-.013-1.206.08-1.671l.05-.252c.146-.757.222-1.55-.56-3.278-3.738-8.098-2.722-3.165-3.5-7.64-.063-.36-.344-1.259-.646-2.197l-.152-.47c-.354-1.093-.693-2.127-.702-2.313-.506 0-.788-.209-1.31-.61-1.34 1.157-3.846 2.87-5.48 3.53 2.78 1.561 3.01 2.881 4.58 4.81 1.047 1.284 3.1 1.19 2.32 2.6-1.977 3.715-1.348 3.82-1.7 3.93-1.914.718-2.002.86-1.707.368l.069-.116c.342-.584.963-1.808.418-3.732-.295-1.116-1.967-2.461-3.705-3.753l-.523-.386C1.85 10.484.014 9.175 0 8.34c-.033-1.28 2.55-4.584 5.48-6.59.16-.054.452.017.857.12l.212.052c1.475.366 4.176.899 7.411-1.873",
    id: "wfugv9yiee"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "22.597%",
    y1: "170.929%",
    x2: "222.217%",
    y2: "-610.354%",
    id: "7a34yjyh4f"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#173889",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3CDEB",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.72 6.775c-.719-.415-2.136 1.138-4.202 1.544-1.184.234-3.25.467-3.537.79-.287.324-.861 1.75.755 2 1.615.252 4.717-.926 6.339-.28 3.736 1.492 1.732-3.427.646-4.054",
    fill: "#F4B3A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.988 33.765c-1.976 3.715-1.346 3.82-1.7 3.93-3.965 1.487-.091.506-1.22-3.48-1.399-5.295-16.694-5.662-.31-15.68.675-.404 2.887 1.213 3.18 1.8.986 1.578-5.147 5.333-6.85 6.02 2.78 1.561 3.01 2.88 4.58 4.81 1.048 1.284 3.1 1.19 2.32 2.6",
    fill: "#F3A391"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.769 22.545c-.504.293-3.573 1.173-4.42.79-.802-.363-2.768-2.16-3.09-3.1-.581-1.74-.542-12.108.75-13.4.8-.837 1.039-.409 2.21.33.687.438 3.649 2.331 4.11 2.99 1.994 2.854-1.095 5.91-.44 7.36 0 .101 2.853 3.811.88 5.03",
    fill: "#F3A391"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.949 18.445c-.15-1.568.208.623 3.68 1.5 1.692.428 3.616-.025 3.44-1.73-.072-.65-.42-1.026.18-.15 4.64 5.416-5.971 8.791-7.3.38",
    fill: "#FF6216"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.527 6.132c-.053.716-3.932 6.204 3.413 3.624 0 0-.791-.536-.827-1.9-.06-2.244.635-1.724-2.586-1.724",
    fill: "#F19E8C"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 9.097)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "9ncjlze9lb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#opklzt8tca"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.921 4.462c-2.663-.904-2.035-.348-2.74-.449C1.077 4-.43 5.12.12 5.091c.371-.02.425-.35 1.956-.4 1.767 1.294-.57.976-.76 1.064-.31.144.66.437.725.51.925 1.01 5.854-3.669 6.16-4.167.06-.1.088-5.965-4.28 2.364",
    fill: "#F19E8C",
    mask: "url(#9ncjlze9lb)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.549 11.806c-2.467-.288-2.027 1.684-3.852 5.997-3.426.589-8.992 1.22-5.593 2.01 1.566.366 4.92.72 5.979.504 2.705-.55 5.319-8.093 3.466-8.511",
    fill: "#F8B4A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.962 16.905c-5.413-.464-2.347.491-.908 1.55-5.315-1.626 3.35 3.058 2.519.198-.101-.347-1.493-1.738-1.611-1.748M24.799 40.915c0 .706.044 1.06-1.44 1.56 0 .1-.735 1.055-1.05-1.22-.282-2.02.916-2.226-.43-5.2-3.738-8.098-2.723-3.165-3.5-7.64-.809-4.647-3.376-4.963 1.06-7.92 3.485-.794 2.465 5.574 2.18 9.29 2.047 1.918 3.18 8.544 3.18 11.13",
    fill: "#F8B4A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.731 1.463c-.126.09-1.173 2.119-1.233 2.652-.06.532.108.819.096 1.113-.012.293-.21.576-.228 1.12-.018.544.198 1.831.198 2.154 0 .384 3.648 1.482 4.884-1.221.745.638 2.336-2.192 1.131-1.868-.467.126-.826.647-1.005.647-1.109 0 1.281-1.685-3.843-4.597",
    fill: "#F5A997"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.948)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "lj97vv1kld",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ix9mpp3hhc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.503 4.203C1.788 2.876 0 2.922 0 2.922s1.72-5.355 6.081-1.566c2.4 2.085-.004 9.484-3.578 2.847",
    fill: "#0A3192",
    mask: "url(#lj97vv1kld)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.445 8.975c-.574-1.18 3.348-2.954 5.434-1.754 1.62 5.798-2.896 4.384-4.167 4.65-1.179.248-1.014-.818-1.267-2.896M17.763 12.867c-.327 1.42-2.057 3.184-.09 4.124 1.966.94 1.79 1.899 2.707.94 4.56-4.759-1.872-8.293-2.617-5.064",
    fill: "#FF7F29"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.079 18.186)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "bnmaobbpag",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#wfugv9yiee"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.72 22.73c0 .706.043 1.058-1.44 1.56 0 .1-.734 1.055-1.05-1.22-.28-2.022.916-2.226-.43-5.2-3.738-8.099-2.722-3.166-3.5-7.64-.147-.843-1.482-4.61-1.5-4.98-.506 0-.788-.21-1.31-.61-1.34 1.156-3.846 2.87-5.48 3.53 2.78 1.56 3.01 2.88 4.58 4.81 1.047 1.283 3.1 1.19 2.32 2.6-1.977 3.714-1.348 3.82-1.7 3.93-3.966 1.486-.092.505-1.22-3.48C7.341 13.572.028 10.01 0 8.34c-.033-1.28 2.55-4.584 5.48-6.59.718-.24 4.113 2.041 8.48-1.7.368-.37 1.35 1.422 1.35 3 .78 1.3.415 6.134.23 8.55.8.748 2.06 1.755 2.32 6.08.002.047.86 1.39.86 5.05",
    fill: "url(#7a34yjyh4f)",
    mask: "url(#bnmaobbpag)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwimmer3);
export default __webpack_public_path__ + "static/media/swimmer3.f6336e08e2479084638a91c6cf739416.svg";
export { ForwardRef as ReactComponent };